import { useState } from 'react'
import './styles.scss'

interface ButtonProps {
  title: string
  icon?: string | JSX.Element
  onClick: () => void
  disabled?: boolean
  disabledMessage?: string
  type?: 'primary' | 'secondary' | 'warning'
  isGhost?: boolean
  width?: string
}

function Button({
  title,
  icon = <></>,
  onClick,
  disabled = false,
  type = 'secondary',
  width = '100%',
  disabledMessage,
  isGhost = false,
}: ButtonProps) {
  const isVisibleTooltip = !!(disabledMessage !== undefined && disabled)

  const [showMessage, setIsShowMessage] = useState(false)
  const [showMessageAux, setIsShowMessageAux] = useState(false)

  return (
    <button
      className={`btn btn-${type} ${isGhost ? 'ghost' : ''}`}
      disabled={disabled}
      onClick={() => {
        onClick()
      }}
      style={{ width }}
      id={title}
      onMouseOver={() =>
        setTimeout(() => {
          !showMessage && setIsShowMessage(true)
        }, 200)
      }
      onMouseOut={() =>
        setTimeout(() => {
          !showMessageAux && setIsShowMessage(false)
        }, 200)
      }
    >
      {((showMessage && isVisibleTooltip) ||
        (showMessageAux && isVisibleTooltip)) && (
        <div
          className="tooltip"
          onMouseOver={() => {
            setIsShowMessageAux(true)
          }}
          onMouseOut={() => {
            setIsShowMessageAux(false)
          }}
        >
          {disabledMessage}
          <div></div>
        </div>
      )}

      <div className={`btn content`}>
        <div className={`content-icon`}>{icon}</div>
        <strong>{title}</strong>
      </div>
    </button>
  )
}

export default Button
